/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/import-syncs/test_sync_connection" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postIntegrationsDirectCdiImportSyncsTestConnectionCacheKeys } from "./constants";
import type {
  PostIntegrationsDirectCdiImportSyncsTestConnectionProps,
  PostIntegrationsDirectCdiImportSyncsTestConnectionResult,
} from "./types";

export const postIntegrationsDirectCdiImportSyncsTestConnection = reactQueryMutationAdapter(
  postIntegrationsDirectCdiImportSyncsTestConnectionCacheKeys,
  (
    props: PostIntegrationsDirectCdiImportSyncsTestConnectionProps
  ): Promise<PostIntegrationsDirectCdiImportSyncsTestConnectionResult> => {
    return fetch("/integrations/direct/cdi/import-syncs/test_sync_connection", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
